import * as React from "react";
import { createSvgIcon } from "@mui/material";

export default createSvgIcon(
  <svg
    width="60"
    height="46"
    viewBox="0 0 60 46"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.00112 26.215C5.33452 24.6753 5.3347 20.8262 8.00143 19.2868L27.1276 8.24541C29.7944 6.70592 33.1276 8.63058 33.1275 11.7098L33.1265 33.7942C33.1263 36.8734 29.7929 38.7978 27.1263 37.2581L8.00112 26.215Z"
      stroke="#81BC00"
      strokeWidth="2"
    />
    <path
      d="M22.3253 26.2159C19.6587 24.6762 19.6589 20.8272 22.3256 19.2877L41.4518 8.24638C44.1186 6.7069 47.4518 8.63155 47.4517 11.7108L47.4507 33.7952C47.4506 36.8744 44.1171 38.7988 41.4505 37.259L22.3253 26.2159Z"
      stroke="#81BC00"
      strokeWidth="2"
    />
  </svg>,
  "ArrowPreviousIcon"
);
